var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"demo"}},[_c('b-carousel',{staticClass:"shadow",staticStyle:{"text-shadow":"0px 0px 2px #000"},attrs:{"id":"carousel-fade","fade":"","indicators":"","img-width":"1024","img-height":"480"}},_vm._l((_vm.slide_info),function(item,index){return _c('b-carousel-slide',{key:index,attrs:{"img-src":item.info_img}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }